import Component from 'Spackle/Components/Component';

export default class Form extends Component {
    params() {
        return {
            accountId: $('#accountId').val()
        };
    }

    showErrors(container, data) {
        var errorsContainer;
        $.each(data.response.errors, function (key, value) {
            errorsContainer = container.find(value.target);
            if (!errorsContainer.html()) {
                errorsContainer.html('<ul></ul>').show();
            }
            errorsContainer.find('ul').append('<li>'+value.message+'</li>');
        });

        // scroll to the errors if there are any
        if (errorsContainer) {
            container.closest('.modal').scrollTop(
                errorsContainer.offset().top - errorsContainer.offset().top + errorsContainer.scrollTop()
            );
        }
    }

    load(containerId, componentId) {
        var data = {
            url: this.data(),
            params: this.params()
        };

        var self = this;

        var container = $(containerId);
        container.closest('.modal').modal('show');

        // wait until after the content is loaded into the modal
        var mainForm = this;
        container.unbind('load.rendered').on('load.rendered', function () {
            // bind form submission to save
            container.find('form').submit(function () {
                // include params() and the form values
                var form = $(this);
                var formArray = form.serializeArray();
                var params = self.params();

                // disable submit buttons
                form.find('button[type=submit]').each(function () {
                    $(this).attr('data-old-value', $(this).html());
                    $(this).html('Please wait...');

                    var $this = $(this);
                    setTimeout(function () {
                        // this is a race condition with the client-side validation
                        // where client side will enable the button immediately
                        // after it is disabled here
                        // adding a slight delay eliminates the issue
                        $this.prop('disabled', true);
                    }, 100);
                });

                for (var i in params) {
                    formArray.push({
                        name: i,
                        value: params[i]
                    });
                }

                $.post($(this).attr('action'), formArray, function (data) {
                    if (data.status == 'success') {
                        container.closest('.modal').modal('hide');
                    } else {
                        self.showErrors(container, data);
                    }
                    $(containerId).trigger('form.saved'+componentId);

                    // re-enable submit buttons
                    form.find('button[type=submit]').each(function () {
                        $(this).html($(this).attr('data-old-value'));
                        $(this).removeAttr('data-old-value');
                        $(this).prop('disabled', false);
                    });

                    mainForm.onSuccess();
                });
                return false;
            });

            // formvalidation.io fails to reenable after remote validation call
            // so we have to add the manual call on success to reenable submit
            container.find('form').formValidation()
                .on('success.field.fv', function(e, data) {
                    container.find('.btn-primary').prop('disabled', false).removeClass('disabled');
                })
                .on('success.form.fv', function(e) {
                    e.preventDefault(); // don't submit the form twice
                });

            mainForm.onLoad(container);
        });

        return this.loader.load(containerId, this.templateId(), data, this.process());
    }

    submit(form) {
    }

    process() {
        return function (data) {
            return data.response;
        }
    }

    onLoad() {
    }

    onSuccess() {
    }
}
